(() => {
  const show = () => window.tsPageLoading?.show();
  document.addEventListener('click', (event) => {
    const link = event.target.closest('a[href]');
    if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || link.hasAttribute('download') || (link.target && link.target !== '_self')) return;
    const url = new URL(link.href, location.href);
    if (url.origin !== location.origin || !/^https?:$/.test(url.protocol) || (url.pathname === location.pathname && url.search === location.search) || link.matches('[data-ts-wishlist-trigger],[data-ts-mobile-cart-trigger],[data-ts-drawer-search],[data-ts-drawer-close]')) return;
    // Native click listeners can have microtask checkpoints between them.
    // Wait for every handler (including AJAX pagination) to prevent navigation.
    setTimeout(() => { if (!event.defaultPrevented) show(); }, 0);
  });
  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (form.method.toLowerCase() !== 'get' || (form.target && form.target !== '_self')) return;
    setTimeout(() => { if (!event.defaultPrevented) show(); }, 0);
  });
})();
